export const message = {
  taskBulkActionSuccess: 'Task dynamic action successfully updated'
}